export class Organization {
  id: number;
}
